import { useNavigate } from "react-router-dom";
import { MyTrackerTabs } from "../../utils/constants";

interface PortfolioTrackerHeaderProps {
  tabIndex: number;
  tabName: string;
  children?: React.ReactNode;
  hasProperties?: boolean;
  hasPropertiesWithDifferentCurrency?: boolean;
}

const PortfolioTrackerHeader: React.FC<PortfolioTrackerHeaderProps> = ({
  tabIndex,
  tabName,
  children,
  hasProperties,
  hasPropertiesWithDifferentCurrency,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex flex-row w-full ">
        <div className="flex flex-col gap-4 w-1/2 p-4 text-start">
          <div className="text-2xl font-bold">Portfolio Tracker — {tabName}</div>
          <div>
            {tabIndex != 4 && tabIndex != 7 && (
              <a
                id="pthdr-lnk-printview"
                data-testid="pthdr-lnk-printview"
                href="#"
                onClick={() => window.print()}
                className="text-gray-500 hover:underline no-underline text-start"
                title="Show Print View"
              >
                Print View <i className="pi pi-print "></i>
              </a>
            )}
          </div>
          {tabIndex == 1 && hasPropertiesWithDifferentCurrency && (
            <div className="text-sm text-sky-500">
              * Your portfolio contains properties that use different currencies. All values here are shown in AUD.
            </div>
          )}

          {tabIndex == 4 && (
            <div className="text-sm ">
              Keep a record of each of your properties here. You can add a new property or import a property from
              Analyser.
            </div>
          )}
        </div>
        {(tabIndex == MyTrackerTabs.MyTracker ||
          tabIndex == MyTrackerTabs.MyEquity ||
          tabIndex == MyTrackerTabs.MyCashFlow) && <div className="w-1/2 p-4">{children}</div>}
      </div>
      {(tabIndex == MyTrackerTabs.MyProperties ||
        tabIndex == MyTrackerTabs.MyEntitiesGoals ||
        tabIndex == MyTrackerTabs.MyPhonebook ||
        tabIndex == MyTrackerTabs.ManageProperty) && <div className="flex flex-row">{children}</div>}
      {tabIndex == 1 && !hasProperties && (
        <div className="flex mb-6">
          <span>
            You currently don't have any properties in this entity. You can{" "}
            <a
              id="pthdr-lnk-selectexisting-1"
              data-testid="pthdr-lnk-selectexisting-1"
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                navigate(`/portfolio-tracker`, {
                  state: {
                    tab: "MyPropertyTab",
                  },
                });
              }}
            >
              select an existing property
            </a>{" "}
            from another entity to add to it, or you can{" "}
            <a
              id="pthdr-lnk-addnew-1"
              data-testid="pthdr-lnk-addnew-1"
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                navigate(`/portfolio-tracker`, {
                  state: {
                    tab: "MyPropertyTab",
                    AddNewProperty: true,
                  },
                });
              }}
            >
              add a new property
            </a>{" "}
            to your portfolio and assign it here.
          </span>
        </div>
      )}
      {tabIndex == 2 && !hasProperties && (
        <div className="flex mb-6">
          <span>
            You currently don't have any properties in this entity. You can{" "}
            <a
              id="pthdr-lnk-selectexisting-2"
              data-testid="pthdr-lnk-selectexisting-2"
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                navigate(`/portfolio-tracker`, {
                  state: {
                    tab: "MyPropertyTab",
                  },
                });
              }}
            >
              select an existing property
            </a>{" "}
            from another entity to add to it, or you can{" "}
            <a
              id="pthdr-lnk-addnew-2"
              data-testid="pthdr-lnk-addnew-2"
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                navigate(`/portfolio-tracker`, {
                  state: {
                    tab: "MyPropertyTab",
                    AddNewProperty: true,
                  },
                });
              }}
            >
              add a new property
            </a>{" "}
            to your portfolio and assign it here.
          </span>
        </div>
      )}
      {tabIndex == 3 && !hasProperties && (
        <div className="flex mb-6">
          <span>
            You currently don't have any properties in this entity. You can{" "}
            <a
              id="pthdr-lnk-selectexisting-3"
              data-testid="pthdr-lnk-selectexisting-3"
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                navigate(`/portfolio-tracker`, {
                  state: {
                    tab: "MyPropertyTab",
                  },
                });
              }}
            >
              select an existing property
            </a>{" "}
            from another entity to add to it, or you can{" "}
            <a
              id="pthdr-lnk-addnew-3"
              data-testid="pthdr-lnk-addnew-3"
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                navigate(`/portfolio-tracker`, {
                  state: {
                    tab: "MyPropertyTab",
                    AddNewProperty: true,
                  },
                });
              }}
            >
              add a new property
            </a>{" "}
            to your portfolio and assign it here.
          </span>
        </div>
      )}
    </>
  );
};

export default PortfolioTrackerHeader;
